export default __webpack_public_path__ + "static/media/cleantech-full.620b0b64.png";